import { useMutation } from '@tanstack/react-query';

import {
  markNotificationAsRead,
  type MarkNotificationReadPayload,
} from '@/api/v4/notifications.api';
import { queryClient, QueryKey } from '@/config/query-client';
import { notify } from '@/ui/snackbar/notify';
import { useTranslation } from 'react-i18next';

export const useMarkNotificationAsRead = () => {
  const { t } = useTranslation('default');

  const mutation = useMutation({
    mutationFn: markNotificationAsRead,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.Notifications],
      });
    },
    onError: () => {
      notify({
        message: t`unknownError`,
      });
    },
  });

  const markAsRead = (payload?: MarkNotificationReadPayload) =>
    mutation.mutateAsync(payload ?? {});

  return {
    markAsRead,
    isLoading: mutation.isPending,
    isError: mutation.isError,
  };
};
